import type { Account, Role } from 'types';

export const isInfluencerRealm = (roles: Array<Role>): boolean => (
  roles.some(r => r === 'INFLUENCER_REALM')
);

export const isPayoutRealm = (roles: Array<Role>): boolean => (
  roles.some(r => r === 'PAYOUT_REALM')
);

export const isCcmModerator = (roles: Array<Role>): boolean => (
  roles.some(r => r === 'CCM_MODERATOR')
);

export function isAdmin(account: Account, roles: Array<Role>) {
  return Boolean(account?.admin)
    || (roles || []).some(r => r === 'ADMIN');
}

export function isCollabarySupport(account: Account) {
  return account && account.email === 'collabary_support@zalando.de';
}

export function isCollabaryCreatorSupport(account: Account) {
  return account && account.email === 'collabary_support+creator@zalando.de';
}

export const canRelatedOrgEditThisProfile = (
  account: Pick<Account, 'organizations'>,
  influencerProfileId: number
): boolean => {
  const organizations = account?.organizations || [];

  return organizations.some(org => (
    (org.influencerProfiles || []).some(ip => (
      ip.id === influencerProfileId
    ))
  ));
};
